import { Provider } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
import { NOTIFICATION_SERVICE } from '../notification/notification';
import { NotificationService } from '../notification/notification.service';
import { CleanupService } from './cleanup.service';
import { FormPersistenceService } from './form-persistence.service';
import { LocalStorageService } from './local-storage.service';
import { DRAFT_PERSISTANT_CONFIG } from './persistence.interface';
import { SessionManagerService } from './session-manager.service';

export function provideStorage(): Provider[] {
	return [
		LocalStorageService,
		CleanupService,
		SessionManagerService,
		FormPersistenceService,
		{
			provide: NOTIFICATION_SERVICE,
			useClass: NotificationService,
		},
		MatSnackBar,
		{
			provide: DRAFT_PERSISTANT_CONFIG,
			useValue: environment.draftStorageConfig,
		},
	];
}
